<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignPopup"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize14 text-white">Add Template</h2>
      </div>
      <div>
        <div class="px-2">
          <div>
            <!-- <feather-icon
              icon="XIcon"
              svgClasses="w-4 h-4"
              class="flex justify-end cursor-pointer text-black"
              @click="
                () => {
                  isshowCampaignPopup = false;
                }
              "
            /> -->
            <!-- <p class="fsize14 font-semibold text-4f4f4f mb-0">Add Template</p> -->

            <!-- <el-select
              v-model="selectedCampaign"
              class="mt-2"
              placeholder="Enter.."
            >
              <el-option
                v-for="item in Campaignoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="mt-2 w-full"
              >
              </el-option>
            </el-select> -->
            <div class="flex justify-center gap-3">
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('template-Whatsappcampaign')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp01.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('marcom-SMSTemplate')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/sms.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('template-Pushnotification')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/push.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('marcom-Templateselect')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/email.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
            </div>
          </div>

          <div class="justify-end flex mt-8 items-center">
            <!-- <vs-button
              @click="handleClick"
              :disabled="selectedCampaign === ''"
              color="primary"
              class="w-full bg-primary border-0 rounded-full text-white font-normal lg:py-3 fsize14 md:py-3 py-2 px-4 sm-fsize14"
            >
              Confirm Template
            </vs-button> -->
            <!-- <vs-button
              type="secondary"
              class="bg-secondary rounded-full border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 px-4 sm-fsize14"
              @click="
                () => {
                  isshowCampaignPopup = false;
                }
              "
            >
              Cancel
            </vs-button> -->
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="30%"
      :visible.sync="isshowCampaignpreview"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title">
        <h2 class="font-semibold fsize14 my-0 text-white">Template Preview</h2>
      </div>
      <div>
        <div class="px-2">
          <div class="rounded-6px relative">
            <!-- <img
              alt="image"
              class="temp-previewh"
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom.svg"
            /> -->
            <!-- sms -->
            <div class="bg-f4f5f6 p-4 rounded-lg" v-if="value0 === 'SMS'">
              <p class="text-dark fsize12">
                Note: {{ smsBody }} <br /><a href="" class="col-61">{{
                  url
                }}</a>
              </p>
            </div>

            <div
              class="absolute topright-10px flex items-center justify-end gap-2 mb-1"
            >
              <!-- <feather-icon
                icon="EditIcon"
                class="cursor-pointer mt-1"
                svgClasses="w-4 h-4"
              /> -->
            </div>

            <!-- pushn -->

            <div class="mt-4" v-if="value0 === 'Push Notification'">
              <div
                class="flex justify-between items-center bg-cbe3ec py-2 px-4 rounded-tlr-20px"
              >
                <div class="flex items-center">
                  <img
                    :src="
                      brandProfile.primaryLogo
                        ? `${this.$imageURL}` + brandProfile.primaryLogo
                        : `data:image/png;base64,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`
                    "
                    alt="logo"
                    class="w-8 h-8"
                  />
                  <p class="font-medium pl-2 mb-0 text-8f8f8f">
                    {{ selectedProject.projectName }}
                  </p>
                </div>
                <small class="text-8f8f8f fsize10">7m ago</small>
              </div>
              <div class="bg-8ec1d4 rounded-blr-20px text-left p-4">
                <h4 class="text-black fsize14 mb-0">{{ title }}</h4>
                <p class="mb-0 fsize12 text-black">
                  {{ pushBody }}
                </p>
              </div>
            </div>
            <!-- whatsapp -->
            <div
              class="mt-4 rounded-10px bg-f4f5f6 py-4 px-4"
              v-if="value0 === 'Whats App'"
            >
              <div v-if="type == 'image'">
                <img
                  :src="
                    media
                      ? $imageURL + '/' + media
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full h-110px object-cover"
                  alt="image"
                />
              </div>
              <div v-if="type == 'video'">
                <video
                  :src="
                    media
                      ? $imageURL + '/' + media
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full h-110px object-cover"
                  alt="image"
                ></video>
              </div>
              <div v-if="type == 'file'">
                <iframe
                  :src="
                    media
                      ? $imageURL + '/' + media
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full h-110px object-cover"
                  alt="image"
                ></iframe>
              </div>
              <div v-if="type == 'variable'"></div>
              <p class="text-black fsize12"></p>
              <p v-if="!this.buttonTitle" v-html="whatsappBody"></p>
              <p
                v-if="this.buttonTitle"
                v-html="whatsappBody.split('|')[0]"
              ></p>
              <!-- <p
                v-if="this.buttonTitle"
                v-html="whatsappBody.split('|')[1]"
              ></p> -->
              <div v-if="this.buttonTitle" class="w-full rounded-10px bg-white">
                <p class="text-blue fsize12 text-center">
                  {{ buttonTitle }}
                </p>
              </div>
              <div
                v-if="this.buttonTitle1"
                class="w-full rounded-10px bg-white"
              >
                <p class="text-blue fsize12 text-center">
                  {{ buttonTitle1 }}
                </p>
              </div>
              <br />
              <div class="text-right">
                <small class="text-646464">{{ timeFormat }}</small>
              </div>
            </div>

            <!-- Email -->
            <!-- Email Template 1 -->
            <div v-if="value0 === 'Email'">
              <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 0">
                <div
                  class="rounded-6px bg-f4f5f6 flex justify-center h-full w-full"
                >
                  <img
                    :src="
                      this.image1Source
                        ? image1Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full h-full rounded-10px h150px object-cover"
                    alt="image1"
                  />
                </div>

                <div class="mt-4">
                  <p class="text-white" v-html="body1"></p>

                  <!-- <p class="text-white">Hi,</p>

                <p class="text-white">
                  Make your emails pop with an attractive banner. Make your
                  emails pop with an attractive banner.
                </p>

                <p class="text-white py-8">
                  Make your emails pop with an attractive banner.<a
                    href="https://brained.app"
                    >https://brained.app</a
                  >
                </p> -->

                  <p class="text-white mb-1">Thankyou,</p>
                  <p class="text-white">
                    {{ this.selectedProject.displayName }}
                  </p>
                </div>

                <div class="mt-10">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                    alt="instagram"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                    alt="youtube"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                    alt="facebook"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                    alt="twitter"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                    alt="whatsapp"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                    alt="linkedin"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                </div>
              </div>

              <!-- Email Template 2 -->
              <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 1">
                <div class="rounded-6px bg-f4f5f6 h-32">
                  <img
                    :src="
                      this.image1Source
                        ? image1Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full rounded-md object-cover h-full"
                    alt="image1"
                  />
                </div>

                <div class="mt-4">
                  <p class="text-white" v-html="body1"></p>
                  <!-- <p class="text-white">Hi,</p>

                <p class="text-white">
                  Make your emails pop with an attractive banner. Make your
                  emails pop with an attractive banner.
                </p>

                <p class="text-white py-4">
                  Make your emails pop with an attractive banner.<a
                    href="https://brained.app"
                    >https://brained.app</a
                  >
                </p> -->

                  <p class="text-white mb-1">Thankyou,</p>
                  <p class="text-white">
                    {{ this.selectedProject.displayName }}
                  </p>
                </div>

                <div class="grid grid-cols-3 gap-3 mt-2">
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image2Source
                          ? image2Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image2"
                    />
                  </div>
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image3Source
                          ? image3Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image3"
                    />
                  </div>
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image4Source
                          ? image4Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image4"
                    />
                  </div>
                </div>

                <div class="mt-12">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                    alt="instagram"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                    alt="youtube"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                    alt="facebook"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                    alt="twitter"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                    alt="whatsapp"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                    alt="linkedin"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                </div>
              </div>

              <!-- Email Template 3 -->
              <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 2">
                <div class="rounded-6px bg-f4f5f6 h-32">
                  <img
                    :src="
                      this.image1Source
                        ? image1Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full rounded-md object-cover h-full"
                    alt="image1"
                  />
                </div>

                <div class="mt-6">
                  <div class="flex">
                    <div class="w-1/4">
                      <div class="rounded-6px bg-f4f5f6 h-24">
                        <img
                          :src="
                            this.image2Source
                              ? image2Source
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full rounded-md object-cover h-full"
                          alt="image2"
                        />
                      </div>
                    </div>

                    <div class="w-3/4 pl-4">
                      <!-- <p class="text-white fsize12">
                      Make your emails pop with an attractive banner. Make your
                      emails pop with an attractive banner.
                    </p> -->
                      <p class="text-white fsize12" v-html="body1"></p>
                    </div>
                  </div>

                  <div class="flex mt-6">
                    <div class="w-1/4">
                      <div class="rounded-6px bg-f4f5f6 h-24">
                        <img
                          :src="
                            this.image3Source
                              ? image3Source
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full rounded-md object-cover h-full"
                          alt="image3"
                        />
                      </div>
                    </div>

                    <div class="w-3/4 pl-4">
                      <!-- <p class="text-white fsize12">
                      Make your emails pop with an attractive banner. Make your
                      emails pop with an attractive banner.
                    </p> -->
                      <p class="text-white fsize12" v-html="body2"></p>
                    </div>
                  </div>
                  <div class="mt-6">
                    <p class="text-white mb-1">Thankyou,</p>
                    <p class="text-white">
                      {{ this.selectedProject.displayName }}
                    </p>
                  </div>
                </div>

                <div class="mt-10">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                    alt="instagram"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                    alt="youtube"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                    alt="facebook"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                    alt="twitter"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                    alt="whatsapp"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                    alt="linkedin"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                </div>
              </div>
              <!-- Email Template 4 -->

              <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 3">
                <div class="rounded-6px bg-f4f5f6 h-32">
                  <img
                    :src="
                      this.image1Source
                        ? image1Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full rounded-md object-cover h-full"
                    alt="image1"
                  />
                </div>
                <div class="grid grid-cols-3 gap-3 mt-4">
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image2Source
                          ? image2Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image2"
                    />
                  </div>
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image3Source
                          ? image3Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image3"
                    />
                  </div>
                  <div class="rounded-6px bg-f4f5f6 h-95px">
                    <img
                      :src="
                        this.image4Source
                          ? image4Source
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image4"
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <p class="text-white" v-html="body1"></p>
                  <!-- <p class="text-white">Hi,</p>

                <p class="text-white">
                  Make your emails pop with an attractive banner. Make your
                  emails pop with an attractive banner.
                </p>

                <p class="text-white py-4">
                  Make your emails pop with an attractive banner.<a
                    href="https://brained.app"
                    >https://brained.app</a
                  >
                </p> -->

                  <p class="text-white mb-1">Thankyou,</p>
                  <p class="text-white">
                    {{ this.selectedProject.displayName }}
                  </p>
                </div>

                <div class="mt-10">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                    alt="instagram"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                    alt="youtube"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                    alt="facebook"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />

                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                    alt="twitter"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                    alt="whatsapp"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                    alt="linkedin"
                    class="w-4 mr-4 h-4 object-contain cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mt-12" v-if="status == 'rejected'">
            <h2 class="font-semibold fsize16 text-dark mb-1">Reason:</h2>
            <p class="fsize12 col-4f4f4f opacity-80">
              {{ reason }}
            </p>
          </div>
          <div class="justify-center mt-6 items-center">
            <vs-button
              type="warning"
              class="w-full px-8 py-4 rounded-lg border-0 font-medium fsize14 capitalize"
              :class="{
                'bg-warning': status === 'pending',
                'bg-success': status === 'approved',
                'bg-danger': status === 'rejected',
              }"
            >
              <p class="mb-0 fsize14 font-semibold capitalize">
                {{ status }}
              </p>
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            My Template
          </h2>
        </div>
      </div>
    </div>
    <div class="px-6 py-8 menucontrol-scroll fixed-top bg-white">
      <div class="w-full">
        <div class="w-full flex items-center justify-between">
          <div class="w-4/12">
            <div>
              <small class="fsize12 bg-white text-dark font-medium"
                >Search Keywords</small
              >
              <div class="relative">
                <el-input
                  placeholder="Search"
                  class="w-full mt-2"
                  v-model="input"
                  @onchange="input"
                ></el-input>
                <div class="absolute topright-adj bg-white cursor-pointer">
                  <feather-icon icon="SearchIcon" svgClasses="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
          <div class="w-8/12 flex items-end gap-2 pl-2">
            <div class="w-10/12 flex gap-3">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search by Template</small
                >
                <el-select
                  v-model="value0"
                  placeholder=""
                  class="w-full border-2 mt-2 rounded-lg"
                >
                  <el-option
                    v-for="item in Campaignoptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search From
                </small>
                <el-date-picker
                  v-model="date1"
                  type="date"
                  :picker-options="pickerOptions"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                >
                </el-date-picker>
              </div>
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search to</small
                >
                <el-date-picker
                  v-model="date2"
                  type="date"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="w-2/12 flex justify-end">
              <vs-button
                @click="isshowCampaignPopup = true"
                class="bg-primary px-5 py-3 border-none rounded-lg text-white flex items-center"
              >
                Add New
              </vs-button>
            </div>
          </div>
        </div>
        <div
          class="w-full grid grid-cols-3 gap-8 mt-8"
          v-if="value0 === 'Email'"
        >
          <div
            class="flex items-center bg-white cursor-pointer cust-shadow border-round p-4"
            v-for="(item, index) in Cards.email"
            :key="('item-', +index)"
            @click="handleDetails(item)"
          >
            <div class="flex gap-4 w-10/12">
              <!-- <img
                src="require('@/assests/images/main.png')"
                class="w-20 h-24 object-contain bg-cas rounded-lg"
              /> -->

              <div class="w-full">
                <!-- <small class="col-4f fsize10 font-medium">{{ item.top }}</small> -->
                <h3
                  class="col-4f fsize16 font-semibold mb-0 flex gap-1 items-center"
                >
                  {{ item.templateName }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ item.createdAt.split("T")[0] }}
                    </p>
                  </div>
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
                    <p
                      class="fsize10 mb-0 font-semibold capitalize"
                      :class="{
                        textwarning: item.status === 'pending',
                        'text-success': item.status === 'approved',
                        textdanger: item.status === 'rejected',
                      }"
                    >
                      {{ item.status }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <!-- <img
                  src="@/assets/images/aright.png"
                  class="w-12 h-12 rounded-full"
                /> -->
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-12 h-12"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="w-full grid grid-cols-3 gap-8 mt-8"
          v-if="value0 === 'Push Notification'"
        >
          <div
            class="flex items-center bg-white cursor-pointer cust-shadow border-round p-4"
            v-for="(item, index) in Cards.pushNotification"
            :key="('item-', +index)"
            @click="handleDetails(item)"
          >
            <div class="flex gap-4 w-10/12">
              <!-- <img
                src="require('@/assests/images/main.png')"
                class="w-20 h-24 object-contain bg-cas rounded-lg"
              /> -->

              <div class="w-full">
                <!-- <small class="col-4f fsize10 font-medium">{{ item.top }}</small> -->
                <h3
                  class="col-4f fsize16 font-semibold mb-0 flex gap-1 items-center"
                >
                  {{ item.templateName }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ item.createdAt.split("T")[0] }}
                    </p>
                  </div>
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
                    <p
                      class="fsize10 mb-0 font-semibold capitalize"
                      :class="{
                        textwarning: item.status === 'pending',
                        'text-success': item.status === 'approved',
                        textdanger: item.status === 'rejected',
                      }"
                    >
                      {{ item.status }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <!-- <img
                  src="@/assets/images/aright.png"
                  class="w-12 h-12 rounded-full"
                /> -->
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-12 h-12"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="totalLength === 0">
          <div class="text-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brainedadmin/images/nodatafound.svg"
              alt="image"
              class="w-1/3"
            />
          </div>
        </div>
        <div class="w-full grid grid-cols-3 gap-8 mt-8" v-if="value0 === 'SMS'">
          <div
            class="flex items-center bg-white cursor-pointer cust-shadow border-round p-4"
            v-for="(item, index) in Cards.sms"
            :key="('item-', +index)"
            @click="handleDetails(item)"
          >
            <div class="flex gap-4 w-10/12">
              <!-- <img
                src="require('@/assests/images/main.png')"
                class="w-20 h-24 object-contain bg-cas rounded-lg"
              /> -->

              <div class="w-full">
                <!-- <small class="col-4f fsize10 font-medium">{{ item.top }}</small> -->
                <h3
                  class="col-4f fsize16 font-semibold mb-0 flex gap-1 items-center"
                >
                  {{ item.name }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ item.createdAt.split("T")[0] }}
                    </p>
                  </div>
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
                    <p
                      class="fsize10 mb-0 font-semibold capitalize"
                      :class="{
                        textwarning: item.status === 'pending',
                        'text-success': item.status === 'approved',
                        textdanger: item.status === 'rejected',
                      }"
                    >
                      {{ item.status }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <!-- <img
                  src="@/assets/images/aright.png"
                  class="w-12 h-12 rounded-full"
                /> -->
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-12 h-12"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="w-full grid grid-cols-3 gap-8 mt-8"
          v-if="value0 === 'Whats App'"
        >
          <div
            class="flex items-center bg-white cursor-pointer cust-shadow border-round p-4"
            v-for="(item, index) in Cards.whatsApp"
            :key="('item-', +index)"
            @click="handleDetails(item)"
          >
            <div class="flex gap-4 w-10/12">
              <!-- <img
                src="require('@/assests/images/main.png')"
                class="w-20 h-24 object-contain bg-cas rounded-lg"
              /> -->

              <div class="w-full">
                <!-- <small class="col-4f fsize10 font-medium">{{ item.top }}</small> -->
                <h3
                  class="col-4f fsize16 font-semibold mb-0 flex gap-1 items-center"
                >
                  {{ item.label }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ item.createdAt.split("T")[0] }}
                    </p>
                  </div>
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
                    <p
                      class="fsize10 mb-0 font-semibold capitalize"
                      :class="{
                        textwarning: item.status === 'pending',
                        'text-success': item.status === 'approved',
                        textdanger: item.status === 'rejected',
                      }"
                    >
                      {{ item.status }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <!-- <img
                  src="@/assets/images/aright.png"
                  class="w-12 h-12 rounded-full"
                /> -->
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-12 h-12"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            @current-change="
              (value) => {
                currentPage = value;
                getAll();
              }
            "
            :per-size="perPage"
            :total="totalLength"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import FeatherIcon from "../../../../../../components/FeatherIcon.vue";

// import VueEllipseProgress from "vue-ellipse-progress";
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      FeatherIconselectedCampaign: "",
      isshowCampaignPopup: false,
      isshowCampaignpreview: false,
      value0: "SMS",
      value1: "",
      currentPage: 1,
      perPage: 12,
      totalLength: 0,
      status: "",
      reason: "",
      date1: "",
      date2: "",
      input: "",
      image1Source: "",
      image2Source: "",
      image3Source: "",
      image4Source: "",
      image5Source: "",
      image1: "",
      selectedCampaign: "",
      buttonTitle: "",
      buttonTitle1: "",
      image2: "",
      image3: "",
      image4: "",
      body1: "",
      body2: "",
      body3: "",
      type: "",
      media: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      formDate: null,
      Campaignoptions: [
        {
          value: "marcom-SMSTemplate",
          label: "SMS",
        },
        {
          value: "marcom-Templateselect",
          label: "Email",
        },
        {
          value: "template-Pushnotification",
          label: "Push Notification",
        },
        {
          value: "template-Whatsappcampaign",
          label: "Whats App",
        },
      ],
      img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkA…0QRu0QRu0QRu0QXt3tP8DVgJyJnMS4S8AAAAASUVORK5CYII=",
      Cards: [],
      getMyData: "",
      dateCon1: "",
      dateCon2: "",
      url: "",
      smsBody: "",
      pushBody: "",
      pushtitle: "",
      templateName: "",
      whatsappBody: "",
      templateId: "",
    };
  },
  watch: {
    value0: {
      handler: function (val) {
        // if (val) {
        this.$store.commit("template/TEMPLATE_VALUE_STORE", val);
        this.currentPage = 1;
        this.totalLength = 0;
        this.getAll();
        // }
      },
      deep: true,
    },
    input: debounce(async function () {
      this.getAll();
    }),

    date1: debounce(async function (newValue) {
      if (newValue !== "" && this.date2) {
        this.getAll();
      }
    }),
    date2: debounce(async function (newValue) {
      if (this.date1 && newValue !== "") {
        this.getAll();
      }
    }),
  },
  computed: {
    // filteredSearch() {
    //   if (this.input) {
    //     const query = this.input.toLowerCase();
    //     return this.Cards.sms.filter((x) =>
    //       x.name.toLowerCase().includes(query)
    //     );
    //   } else {
    //     return this.Cards.sms;
    //   }
    // },
  },
  methods: {
    disabledDate(date) {
      const currentDate = new Date();
      return date.getTime() > currentDate.getTime();
    },
    handleClick2(name) {
      this.$router.push({ name: name });
    },
    handleDetails(item) {
      // console.log(item, "HelloMa");
      this.isshowCampaignpreview = true;
      if (this.value0 === "SMS") {
        this.url = item.url;
        this.smsBody = item.smsBody;
        this.status = item.status;
        this.reason = item.reason;
      } else if (this.value0 === "Push Notification") {
        this.pushBody = item.body;
        this.templateName = item.templateName;
        this.title = item.title;
        this.status = item.status;
        this.reason = item.reason;
      } else if (this.value0 === "Whats App") {
        if (item.variableType == true) {
          for (let i = 0; i < item.variables.length; i++) {
            item.format = item.format.replace(
              item.variables[i].varRef,
              item.variables[i].varValue
            );
          }
          let body = item.variable
            ? item.variable
            : item.headerVariable.variableHeaderValue + "<br>" + item.format;
          // let s = JSON.stringify(body);
          // console.log(s.replaceAll("\n", "<br>"));
          this.whatsappBody = body.replaceAll("\n", "<br>");
          this.status = item.status;
          this.reason = item.reason;
          this.type = item.mediaType;
        } else {
          this.whatsappBody = item.format.replaceAll("\n", "<br>");
          this.status = item.status;
          this.reason = item.reason;
          this.type = item.mediaType;
          this.media = item.media ? item.media : "";
          this.buttonTitle = item.buttonTitle ? item.buttonTitle : "";
          this.buttonTitle1 = item.buttonTitle1 ? item.buttonTitle1 : "";
        }
      } else if (this.value0 === "Email") {
        this.templateId = item.templateId;
        if (this.templateId === 0) {
          this.image1Source = `${this.$imageURL}` + "/" + item.image1;
          this.body1 = item.body1;
          this.status = item.status;
          this.reason = item.reason;
        }
        if (this.templateId === 1) {
          this.image1Source = `${this.$imageURL}` + "/" + item.image1;
          this.image2Source = `${this.$imageURL}` + "/" + item.image2;
          this.image3Source = `${this.$imageURL}` + "/" + item.image3;
          this.image4Source = `${this.$imageURL}` + "/" + item.image4;
          this.body1 = item.body1;
          this.body2 = item.body2;
          this.status = item.status;
          this.reason = item.reason;
        }
        if (this.templateId === 2) {
          this.image1Source = `${this.$imageURL}` + "/" + item.image1;
          this.image2Source = `${this.$imageURL}` + "/" + item.image2;
          this.image3Source = `${this.$imageURL}` + "/" + item.image3;

          this.body1 = item.body1;
          this.body2 = item.body2;
          this.status = item.status;
          this.reason = item.reason;
        }
        if (this.templateId === 3) {
          this.image1Source = `${this.$imageURL}` + "/" + item.image1;
          this.image2Source = `${this.$imageURL}` + "/" + item.image2;
          this.image3Source = `${this.$imageURL}` + "/" + item.image3;
          this.image4Source = `${this.$imageURL}` + "/" + item.image4;
          this.body1 = item.body1;
          this.status = item.status;
          this.reason = item.reason;
        }
      }
    },
    async getAll() {
      try {
        if (this.currentPage == 1) {
          let payload = {
            campaign: this.value0,
          };
          if (this.value0 === "SMS") {
            if (this.input) {
              Object.assign(payload, { name: this.input });
            }
            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("template/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          } else {
            if (this.input) {
              Object.assign(payload, { templateName: this.input });
            }

            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("template/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          }
        }
        // if (
        //   inputValue ||
        //   (this.date1 && this.date2) ||
        //   (inputValue && this.date1 && this.date2)
        // ) {
        //   if (this.value0 === "SMS") {
        //     let payload = {
        //       campaign: this.value0,
        //       offset: (this.currentPage - 1) * 10,
        //     };

        //     let data = await this.$store.dispatch("template/getAll", payload);
        //     // console.log(data);
        //     this.Cards = data.data;
        //     this.totalLength = data.data.totalLength;
        //   } else {
        //     let payload = {
        //       campaign: this.value0,
        //       offset: (this.currentPage - 1) * 10,
        //       templateName: inputValue,
        //     };
        //     let data = await this.$store.dispatch("template/getAll", payload);
        //     // console.log(data);
        //     this.Cards = data.data;
        //     this.totalLength = data.data.totalLength;
        //   }
        // }
        else {
          let payload = {
            campaign: this.value0,
            offset: (this.currentPage - 1) * 10,
          };
          if (this.value0 === "SMS") {
            if (this.input) {
              Object.assign(payload, { name: this.input });
            }
            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("template/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          } else {
            if (this.input) {
              Object.assign(payload, { templateName: this.input });
            }

            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("template/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          }
          // const query = this.input.toLowerCase();
          // return this.Cards.sms.filter((x) =>
          //   x.name.toLowerCase().includes(query)
          // );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // async handleNext() {
    //   try {
    //     let payload = {
    //       campaign: this.value0,
    //       offset: (this.currentPage - 1) * 10,
    //     };
    //   } catch (err) {}
    // },
    handleClick() {
      this.$router.push({ name: this.selectedCampaign });
    },

    async imagePreview() {
      // let text = this.brandProfile.primaryLogo;
      // let result = text.includes(`${this.$imageURL}`);
      // console.log(result, "leftDash");
      // if (result === true) {
      //   this.brandProfile.primaryLogo = text;
      // } else {
      //   this.brandProfile.primaryLogo = `${this.$imageURL}/` + text;
      // }
    },
    // async getAll() {
    //   try {
    //     let data = this.$store.dispatch("template/getAll");
    //     console.log(data);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
  },
  mounted() {
    this.value0 = this.valueTemplate ? this.valueTemplate : "SMS";
    this.getAll();
    // this.imagePreview();
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("template", ["valueTemplate"]),
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
};
</script>
